// ─── GLOBAL LOGGER ───────────────────────────────────────────────────────────
// Salvează toate log-urile și erorile în localStorage (persistă la reload).
// Vizibile la /debug
const LOG_KEY = "fm_debug_logs";
const LOG_MAX = 300;
export function addLog(level, ...args) {
  try {
    const msg = args.map(a => {
      if(a instanceof Error) return `${a.name}: ${a.message}`;
      if(typeof a === "object") { try { return JSON.stringify(a); } catch(e){ return String(a); } }
      return String(a);
    }).join(" ");
    const entry = { t: new Date().toISOString(), level, msg };
    const logs = JSON.parse(localStorage.getItem(LOG_KEY) || "[]");
    logs.push(entry);
    if(logs.length > LOG_MAX) logs.splice(0, logs.length - LOG_MAX);
    localStorage.setItem(LOG_KEY, JSON.stringify(logs));
  } catch(e) { /* localStorage plin sau indisponibil */ }
}
export function getLogs() { try { return JSON.parse(localStorage.getItem(LOG_KEY) || "[]"); } catch(e){ return []; } }
export function clearLogs() { try { localStorage.removeItem(LOG_KEY); } catch(e){} }
// expune global pentru a putea apela din orice fișier (ex: supabase.js): window.fmLog("mesaj")
if(typeof window !== "undefined") {
  window.fmLog = (...a) => addLog("log", ...a);
  window.fmErr = (...a) => addLog("error", ...a);
  // Prinde erorile necapturate
  window.addEventListener("error", e => addLog("error", "window.onerror:", e.message, "@", e.filename, e.lineno));
  window.addEventListener("unhandledrejection", e => addLog("error", "promise respinsă:", e.reason?.message || e.reason));
}
